import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'dbm-edit',
    template: require('./dbm-edit.component.html'),
    styles: [require('./dbm-edit.component.scss')]
})
export class DbmEditComponent {
    @Input() public saveDisabled = false;
    @Input() public cancelDisabled = false;
    @Input() public withoutButton = false;

    @Output() public save = new EventEmitter();
    @Output() public cancel = new EventEmitter();
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dbm-components/dbm-edit/dbm-edit.component.ts